import { Link } from "react-router-dom";

import AppLogo from "../layout/AppLogo";

interface AuthCardProps {
  children: React.ReactNode;
}

export default function AuthCard({ children }: AuthCardProps) {
  return (
    <div className="entry-layout__wrapper">
      <div className="entry-layout__content">
        <div className="entry-layout__top-bar">
          <Link to="/" className="entry-layout__logo nolink">
            <AppLogo />
          </Link>
        </div>
        <div className="entry-layout__card">{children}</div>
      </div>
    </div>
  );
}
